import { isToggleFeatureEnabled } from "./ToggleFeature";

export const featureNames = {
  bristol: "bristolFeature",
  hbs: "hbsFeature",
  specialInformationBanner: "specialInfoBannerFeature",
  specialInformationSplitBanner: "specialInfoSplitBannerFeature",
  salesForceLiveAgentMOL: "salesForceLiveAgentMOLFeature",
  salesForceLiveAgentHOL: "salesForceLiveAgentHOLFeature"
};

export const isSpecialInfoSplitBannerFeatureEnabled = () => {
  return isToggleFeatureEnabled(featureNames.specialInformationSplitBanner);
};

export const isSpecialInfoBannerFeatureEnabled = () => {
  return isToggleFeatureEnabled(featureNames.specialInformationBanner);
};

export const isBristolFeatureEnabled = () => {
  return isToggleFeatureEnabled(featureNames.bristol);
};

export const isHBSFeatureEnabled = () => {
 return true;
};

export const isSalesForceLiveAgentMOLFeatureEnabled = () => {
  return isToggleFeatureEnabled(featureNames.salesForceLiveAgentMOL);
};

export const isSalesForceLiveAgentHOLFeatureEnabled = () => {
  return isToggleFeatureEnabled(featureNames.salesForceLiveAgentHOL);
};
